
































import Vue from 'vue';
import moment from 'moment';
import PlaylistTeacherThumbnail from '@/web/components/playlists/PlaylistTeacherThumbnail';

export default Vue.extend({
  name: 'PlaylistTeacherItemCard',
  props: {
    playlist: {
      type: Object as () => PlaylistResponse,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    PlaylistTeacherThumbnail,
  },
  methods: {
    formatDate(date) {
      return moment(date).format('MMM DD, yyyy');
    },
    deletePlaylist(id) {
      this.$emit('deletePlaylist', id);
    },
  },
});
